/** 電源ユニットマスタの絞り込みの開閉を残す localStorage のキー (広域機関マスタとは別。 React mock も別のキー)。 */
export const PLANT_UNIT_MASTER_FILTER_STORAGE_KEY = 'adminPlantUnitMaster'
